import { lazy } from 'react';
import { createBrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import * as Sentry from '@sentry/react';
// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PayRoutes from './PayRoutes';
import LoadingRoutes from './LoadingRoutes';
import Loadable from 'ui-component/Loadable';
import React from 'react';

const PagesLanding = Loadable(lazy(() => import('views/landing')));
Sentry.init({
    dsn: 'https://9e27e494d41a5a06e2b572f14c12e5b8@o4507695927328768.ingest.us.sentry.io/4507696518529024',
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
        })
    ],
    tracesSampleRate: 1.0
});

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
// ==============================|| ROUTING RENDER ||============================== //

const router = sentryCreateBrowserRouter([{ path: '/', element: <PagesLanding /> }, LoginRoutes, MainRoutes, PayRoutes, LoadingRoutes], {
    basename: '/'
});
export default router;
